import { createWidgetNormalizer } from '../create-widget-normalizer';
import { isNumber, isString } from '../fold-helpers';
import {
    expandShorthandFields,
    foldButtonsWrapper,
    FORM_APPEARANCE_RULES,
    parseFieldsText,
} from '../form-shared/form-appearance.normalization';

const AMOUNT_SYNONYM_KEYS = ['price', 'cost', 'sum'] as const;
const PRODUCT_NAME_SYNONYM_KEYS = ['product', 'productTitle', 'itemName'] as const;
const FORM_NAME_SYNONYM_KEYS = ['formName', 'title', 'heading'] as const;

/**
 * The normalization for the payment-form tools — the shared family rules plus three of its own.
 *
 * `price` for `amount` is the one that earns its place: it is what the editor's own label says and
 * what anyone describing this widget in words would write. `title`/`heading` for `paymentFormName`
 * matters for the opposite reason — the field is named as if it were internal bookkeeping, while it
 * is in fact the visible heading, so a model asked to "change the title" reaches for the wrong name
 * by reading the schema correctly.
 */
const paymentFormNormalizer = createWidgetNormalizer({
    before: [parseFieldsText, foldButtonsWrapper],
    rules: [
        ...FORM_APPEARANCE_RULES,
        { target: 'amount', synonyms: AMOUNT_SYNONYM_KEYS, accepts: isNumber },
        { target: 'productName', synonyms: PRODUCT_NAME_SYNONYM_KEYS, accepts: isString },
        { target: 'paymentFormName', synonyms: FORM_NAME_SYNONYM_KEYS, accepts: isString },
    ],
    after: [expandShorthandFields],
    horizontalAlign: true,
});

export function normalizePaymentFormWidgetArgs(raw: unknown): unknown {
    return paymentFormNormalizer.normalize(raw);
}
